import { Button, Modal } from "react-bootstrap";
import { ReassuranceModalDanceProps } from "../interfaces/Timeline";
import { getEndBarForDanceRemoval, getFirstPatternId, getPatternsInDanceAmount, getStartBarForDanceRemoval } from "../services/VisServices";

export function ReassuranceModalDance(props: ReassuranceModalDanceProps) {

  function getPatternsToDeleteInDance(): string {
    if (props.selectedDance < 0) return "";

    let startInBars: number = getStartBarForDanceRemoval(props.choreo, props.selectedDance);
    let endInBars: number = getEndBarForDanceRemoval(props.choreo, props.selectedDance);

    let firstPatternId: number = getFirstPatternId(props.choreo, startInBars, endInBars);
    let patternsInDanceAmount: number = getPatternsInDanceAmount(props.choreo, startInBars, endInBars);

    let patternIdsToRemove = "";
    for (let i=0; i<patternsInDanceAmount; i++) {
      patternIdsToRemove+=String(firstPatternId+i);
      if (i<patternsInDanceAmount-1) {
        patternIdsToRemove+=", "
      }
    }

    return patternIdsToRemove;
  }

  return (
    <Modal
      show={props.showReassuranceModal}
      onHide={() => props.setShowReassuranceModal(false)}
    >
      <Modal.Header closeButton>
        <Modal.Title>Delete dance</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Do you really want to delete this dance? <br /> The following patterns will be deleted: <b>{getPatternsToDeleteInDance()}</b><br />Some intermediate patterns will be lost too!. </p>  
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={() => {
            props.setShowReassuranceModal(false);
          }}
        >
          No
        </Button>
        <Button
          variant="secondary"
          onClick={() => {
            props.setShowReassuranceModal(false);
            props.removeDance(props.selectedDance);
          }}
        >
          Yes
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
